
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artist/[artistId]",
      function () {
        return require("private-next-pages/artist/[artistId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artist/[artistId]"])
      });
    }
  